export default {

    apiKey: state => {
        return state.apiKey;
    },

    alerts: state => {
        return state.alerts;
    },

    loading: state => {
        return state.loading;
    },

    refreshing: state => {
        return state.refreshing;
    },

    showModal: state => {
        return state.showModal;
    },

    user: state => {
        return state.user;
    },

    project: state => {
        return state.user?.project;
    },

    company: state => {
        return state.user?.company;
    },

    companyOnboarded: state => {
        return state.user?.company?.onboarded;
    },

    inviteToken: state => {
        return state.inviteToken;
    },

    redirect: state => {
        return state.redirect;
    },

}